import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// this package animates an elements children to new positions using the flip
// method for smooth 60fps animations
//
// https://aerotwist.com/blog/flip-your-animations/
export var FlipPosition = /*#__PURE__*/_createClass(function FlipPosition(parentEl) {
  var _this = this;

  _classCallCheck(this, FlipPosition);

  _defineProperty(this, "parentEl", void 0);

  _defineProperty(this, "startMap", void 0);

  _defineProperty(this, "endMap", void 0);

  _defineProperty(this, "snapshotStart", function () {
    var children = _toConsumableArray(_this.parentEl.children);

    children.forEach(function (child) {
      _this.startMap.set(child, child.getBoundingClientRect()); // data-anim-state is to workround a browser bug
      // should switch to react motion later


      if (child.getAttribute('data-anim-state') !== 'leave') {
        child.style.transition = 'none';
      }
    });
  });

  _defineProperty(this, "snapshotEnd", function (transition) {
    var children = _toConsumableArray(_this.parentEl.children);

    children.forEach(function (child) {
      // measure forces layout
      _this.endMap.set(child, child.getBoundingClientRect());
    });
    children.forEach(function (child) {
      var dx = _this.endMap.get(child).left - _this.startMap.get(child).left;

      var dy = _this.endMap.get(child).top - _this.startMap.get(child).top; // translate to old position


      if (dx === 0 && dy === 0) {
        return;
      }

      child.style.transform = "translate3d(".concat(-dx, "px, ").concat(-dy, "px, 0)");
    }); // force layout

    _this.parentEl.getBoundingClientRect();

    children.forEach(function (child) {
      child.style.transform = null;
      child.style.transition = transition ? transition : null;

      var onTransitionEnd = function onTransitionEnd() {
        child.style.transition = null;
        child.removeEventListener('transitionend', onTransitionEnd);
      };

      child.addEventListener('transitionend', onTransitionEnd);
    });
  });

  this.parentEl = parentEl;
  this.startMap = new WeakMap();
  this.endMap = new WeakMap();
});